/**
 * Ensures the output is always a {@link Date} object.
 *
 * @param value The value to ensure.
 * @return An `Date`.
 */
export function ensureDate(value: string | number | Date) {
  return value instanceof Date ? value : new Date(value);
}
